import React from 'react'
import { Link } from 'react-router-dom'
import { useStyles } from './styles'

interface PageTitleProps {
  className?: any
  children?: any
  title?: string
  breadcrumbLink?: {
    to: string
    text: string
  }
}

export const PageTitle: React.FC<PageTitleProps> = ({ children, className, title, breadcrumbLink }) => {
  const styles = useStyles()

  if (title !== undefined) {
    return (
      <div className={styles.propertiesTitleContainer}>
        <div className={styles.titleSection}>
          <h1 className={`${styles.propertiesTitle} ${className || ''}`}>
            {breadcrumbLink && (
              <>
                <Link to={breadcrumbLink.to} className={styles.breadcrumbLink}>
                  {breadcrumbLink.text}
                </Link>
                <span className={styles.breadcrumbSeparator}> {' > '} </span>
              </>
            )}
            {title}
          </h1>
        </div>
        {children && <div className={styles.titleActions}>{children}</div>}
      </div>
    )
  }

  return (
    <div className={styles.propertiesTitleContainer}>
      <h1 className={`${styles.propertiesTitle} ${className && className}`}>{children}</h1>
    </div>
  )
}
